module.exports = __webpack_public_path__ + "static/media/hero-renters.b8a1e543.png";